import { render, staticRenderFns } from "./AppOverview.vue?vue&type=template&id=b442358c&"
import script from "./AppOverview.vue?vue&type=script&lang=js&"
export * from "./AppOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports